import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Package, Loader2 } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../components/ui/tooltip';
import { ProductFormModal } from '../Modals/ProductFormModal';

const CreateProductButton = ({ 
  clientId,
  availableItems = [],
  categories = [],
  onProductCreated, 
  fetchAvailableItems,
  disabled = false, 
  size = "default",
  variant = "default",
  className = "",
  showIcon = true,
  showText = true,
  tooltipText = "Crear nuevo producto"
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreating, setIsCreating] = useState(false);

  const handleOpenModal = () => {
    if (!disabled) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsCreating(false);
  };

  const handleProductCreated = (newProduct) => {
    setIsCreating(false);
    setIsModalOpen(false);
    onProductCreated?.(newProduct);
  };

  const handleCreating = (creating) => {
    setIsCreating(creating);
  };

  const buttonContent = (
    <>
      {isCreating ? (
        <Loader2 className={`${showText ? 'mr-2' : ''} animate-spin ${size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-6 w-6' : 'h-5 w-5'}`} />
      ) : showIcon ? (
        <Package className={`${showText ? 'mr-2' : ''} ${size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-6 w-6' : 'h-5 w-5'}`} />
      ) : null}
      {showText && (
        <span>{isCreating ? 'Creando...' : 'Crear Producto'}</span>
      )}
    </>
  );

  const ButtonComponent = (
    <Button
      onClick={handleOpenModal}
      disabled={disabled || isCreating}
      size={size}
      variant={variant}
      className={`
        transition-all duration-200 transform hover:scale-105 
        ${variant === 'default' ? 'bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white shadow-lg hover:shadow-xl' : ''}
        ${variant === 'outline' ? 'border-orange-200 text-orange-600 hover:bg-orange-50 hover:border-orange-300 dark:border-orange-700 dark:text-orange-400 dark:hover:bg-orange-900/20' : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed transform-none' : ''}
        ${className}
      `}
    >
      {buttonContent}
    </Button>
  );

  return (
    <>
      {showText || !tooltipText ? (
        ButtonComponent
      ) : (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              {ButtonComponent}
            </TooltipTrigger>
            <TooltipContent>
              <p>{tooltipText}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}

      <ProductFormModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleProductCreated}
        onLoading={handleCreating}
        mode="create"
        title="Crear Nuevo Producto"
        clientId={clientId}
        availableItems={availableItems}
        categories={categories}
        fetchAvailableItems={fetchAvailableItems}
      />
    </>
  );
};

export default CreateProductButton; 